import { useMemo } from 'react';

import { IFeedback } from 'models';
import { useFetchFeedbacksQuery } from 'store/apis/feedback.api';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

type UseFeedbacks = () => [boolean, IFeedback[]];

export const useFeedbacks: UseFeedbacks = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data: feedbacks, isLoading } = useFetchFeedbacksQuery({ orgSlug, params: {} });

  return useMemo(() => {
    return [isLoading, feedbacks || []];
  }, [isLoading, feedbacks]);
};
